<div class="row test py-5 test" [class.answer-background]="showAnswer">
  <div class="col-12">
    <div class="row justify-content-center">
      <div class="col-auto">
        <p class="text-uppercase knowledge">
          <ng-template [ngIf]="language == 'en'">{{ "Test Your Knowledge" | uppercase }}</ng-template>
          <ng-template [ngIf]="language == 'es'">PON A PRUEBA TUS CONOCIMIENTOS</ng-template>
        </p>
      </div> 
    </div>
    <div class="row justify-content-center mt-4 position-relative">
      <div id="Question" class="col-10 px-4 text-center">
        <h2 class="mb-0" [innerHTML]="question"></h2>
      </div>
      <div class="answer col-12 px-5 text-center position-absolute h-100 d-flex" [class.show-answer]="showAnswer">
        <h2 class="my-auto" [innerHTML]="answer"></h2>
      </div> 
    </div>
    <div class="row justify-content-center mt-5">
      <div class="col-auto">
        <button (click)="checkAnswer()" class="py-0 px-0" [class.o-0]="showAnswer">
          <p class="text-uppercase mb-0">
            <u>
              <ng-template [ngIf]="language == 'en'">{{ "Check Your Answer" | uppercase }}</ng-template>
              <ng-template [ngIf]="language == 'es'">COMPRUEBA TU RESPUESTA</ng-template>
            </u>
          </p>
        </button>
      </div>
    </div>
  </div>
</div>
